import React from 'react';
import { IconDental } from '@tabler/icons-react';
import { useClinic } from '../../context/ClinicContext';

export default function BrandMark({ size, withName = false }) {
  const { clinic } = useClinic();
  return (
    <span className="brand">
      <span className={['brand__mark', size === 'lg' && 'brand__mark--lg', clinic?.logoUrl && 'brand__mark--logo'].filter(Boolean).join(' ')}>
        {clinic?.logoUrl ? <img src={clinic.logoUrl} alt="" /> : <IconDental size={size === 'lg' ? 30 : 22} stroke={2} />}
      </span>
      {withName && <span className="brand__name">{clinic?.name || ''}</span>}
    </span>
  );
}
